const routes = [
  {
    path: '/special/specialshareopera',
    name: 'special-specialshareopera',
    component: () => import('@/views/special/SoapoperaView.vue'),
    meta: {
      title: '科普中国Lite',
    },
  },
];
export default routes;
